import {
    FETCH_STORE_COUPON,
} from "constants/ActionTypes";

const INIT_STATE = [];

 export default (state = INIT_STATE , action) => {
    switch(action.type) {
        case FETCH_STORE_COUPON : {
            if (action.payload == undefined || action.payload == []) {
                return state;
            } else {
                const newState = action.payload.map( (value) => {
                    return value
                });
                return newState;
            }
        } ;
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/appRedux/reducers/StoreCoupons.js